"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get Headings () {
        return Headings;
    },
    get LabelSizes () {
        return LabelSizes;
    },
    get NumberTypes () {
        return NumberTypes;
    },
    get booleanInputSchema () {
        return booleanInputSchema;
    },
    get customMapGeometryAttachmentSchema () {
        return customMapGeometryAttachmentSchema;
    },
    get damageDegreeSchema () {
        return damageDegreeSchema;
    },
    get dateSchema () {
        return dateSchema;
    },
    get documentUploaderSchema () {
        return documentUploaderSchema;
    },
    get groupSchema () {
        return groupSchema;
    },
    get multiSelectSchema () {
        return multiSelectSchema;
    },
    get numberSchema () {
        return numberSchema;
    },
    get numberWithUnitsSchema () {
        return numberWithUnitsSchema;
    },
    get propertyAttachmentSchema () {
        return propertyAttachmentSchema;
    },
    get propertyMarketValueSchema () {
        return propertyMarketValueSchema;
    },
    get schemas () {
        return schemas;
    },
    get selectSchema () {
        return selectSchema;
    },
    get tagsSchema () {
        return tagsSchema;
    },
    get textAreaSchema () {
        return textAreaSchema;
    },
    get textSchema () {
        return textSchema;
    },
    get uniqueIdSchema () {
        return uniqueIdSchema;
    },
    get userSchema () {
        return userSchema;
    }
});
const _authorization = require("../../authorization");
const _constants = require("../../constants");
const LabelSizes = [
    "small",
    "medium"
];
const Headings = [
    "h1",
    "h2"
];
const NumberTypes = [
    "ascending",
    "random"
];
const defaultValuePath = {
    type: "string"
};
const columnHeaderOverride = {
    type: "string"
};
const disabled = {
    type: "boolean"
};
const helperText = {
    type: "string"
};
const viewOnCreate = {
    type: "array",
    items: {
        type: "string"
    }
};
const viewOnRetrieve = {
    type: "array",
    items: {
        type: "string",
        enum: _authorization.RoleNames
    },
    minItems: 1
};
const canUpdate = {
    type: "array",
    items: {
        type: "string"
    }
};
const formula = {
    type: "object",
    properties: {
        name: {
            type: "string"
        },
        applies: {
            type: [
                "object",
                "boolean"
            ],
            additionalProperties: true
        },
        logic: {
            type: "object",
            additionalProperties: true
        }
    },
    required: [
        "name",
        "applies",
        "logic"
    ],
    additionalProperties: false
};
const numberSchema = {
    title: "Number",
    type: "object",
    properties: {
        inputType: {
            type: "string",
            enum: [
                "number"
            ]
        },
        type: {
            type: "string",
            enum: [
                "number"
            ]
        },
        name: {
            type: "string"
        },
        placeholder: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        title: {
            type: "string",
            minLength: 1
        },
        step: {
            type: "number"
        },
        minimum: {
            type: "number"
        },
        maximum: {
            type: "number"
        },
        prefix: {
            type: "string"
        },
        postfix: {
            type: "string"
        },
        defaultValuePath,
        defaultValue: {
            type: "number"
        },
        labelSize: {
            type: "string",
            // this is weird, but the fact that LABEL_SIZES is a read-only array
            // causes problems with the validation library, so we duplicate it here
            enum: [
                ...LabelSizes
            ]
        },
        columnHeaderOverride,
        disabled,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        formula
    },
    required: [
        "inputType",
        "type",
        "name",
        "required",
        "title"
    ],
    additionalProperties: false
};
const documentUploaderSchema = {
    title: "Document Upload",
    type: "object",
    properties: {
        inputType: {
            type: "string",
            enum: [
                "DocumentUploader"
            ]
        },
        name: {
            type: "string"
        },
        title: {
            type: "string",
            minLength: 1
        },
        tooltipText: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        accountDocumentType: {
            type: "string",
            minLength: 1
        },
        documentTypeAbbreviation: {
            type: "string",
            minLength: 1
        },
        documentTypeName: {
            type: "string"
        },
        emptyFilesMessage: {
            type: "string"
        },
        fileQuantityDescription: {
            type: "string",
            minLength: 1
        },
        fileSizeDescription: {
            type: "string",
            minLength: 1
        },
        fileTypeDescription: {
            type: "string",
            minLength: 1
        },
        columnHeaderOverride,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        maxItems: {
            type: "integer",
            minimum: 1
        },
        minItems: {
            type: "integer"
        }
    },
    required: [
        "inputType",
        "name",
        "required",
        "maxItems",
        "title",
        "fileTypeDescription",
        "fileQuantityDescription",
        "fileSizeDescription",
        "accountDocumentType",
        "documentTypeName",
        "documentTypeAbbreviation"
    ],
    allOf: [
        {
            if: {
                properties: {
                    required: {
                        const: true
                    }
                }
            },
            then: {
                required: [
                    "minItems"
                ],
                properties: {
                    minItems: {
                        type: "number",
                        minimum: 1
                    }
                }
            }
        }
    ],
    additionalProperties: false
};
const tagsSchema = {
    title: "Tags",
    type: "object",
    properties: {
        inputType: {
            type: "string",
            enum: [
                "Tags"
            ]
        },
        name: {
            type: "string"
        },
        type: {
            type: "string",
            enum: [
                "string",
                "number"
            ]
        },
        title: {
            type: "string",
            minLength: 1
        },
        required: {
            type: "boolean"
        },
        description: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        columnHeaderOverride,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        minItems: {
            type: "integer"
        },
        enum: {
            type: "array",
            items: {
                type: "string",
                minLength: 1
            },
            minItems: 1
        },
        defaultValue: {
            type: "array",
            items: {
                type: "string"
            }
        }
    },
    required: [
        "inputType",
        "name",
        "type",
        "title",
        "required",
        "minItems",
        "enum"
    ],
    additionalProperties: false
};
const propertyAttachmentSchema = {
    type: "object",
    properties: {
        type: {
            type: "string",
            enum: [
                _constants.OBJECT_TYPE.PROPERTY
            ]
        }
    },
    required: [
        "type"
    ],
    additionalProperties: false
};
const customMapGeometryAttachmentSchema = {
    type: "object",
    properties: {
        type: {
            type: "string",
            enum: [
                _constants.OBJECT_TYPE.CUSTOM_MAP_GEOMETRY
            ]
        },
        tags: {
            type: "array",
            items: {
                type: "string",
                minLength: 1
            }
        },
        customMapIds: {
            type: "array",
            items: {
                type: "string",
                minLength: 1
            },
            minItems: 1
        }
    },
    required: [
        "type",
        "customMapIds"
    ],
    additionalProperties: false
};
const selectSchema = {
    title: "Select",
    type: "object",
    properties: {
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        useAsTag: {
            type: "boolean"
        },
        type: {
            type: "string",
            enum: [
                "string"
            ]
        },
        inputType: {
            type: "string",
            enum: [
                "select"
            ]
        },
        placeholder: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        title: {
            type: "string",
            minLength: 1
        },
        enum: {
            type: "array",
            items: {
                oneOf: [
                    {
                        title: "Select Option String",
                        type: "string",
                        minLength: 1
                    },
                    {
                        title: "Select Option Label/Value Pair",
                        type: "object",
                        properties: {
                            label: {
                                type: "string",
                                minLength: 1
                            },
                            value: {
                                type: "string",
                                minLength: 1
                            },
                            display: {
                                type: [
                                    "string",
                                    "null"
                                ],
                                enum: Object.values(_constants.TAG_DISPLAY)
                            }
                        },
                        required: [
                            "label",
                            "value"
                        ]
                    }
                ]
            },
            minItems: 1
        },
        defaultValuePath,
        defaultValue: {
            type: "string"
        },
        columnHeaderOverride,
        disabled,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        randomizeOptionOrder: {
            type: "boolean"
        }
    },
    required: [
        "name",
        "required",
        "type",
        "inputType",
        "placeholder",
        "title",
        "enum"
    ],
    additionalProperties: false
};
const textAreaSchema = {
    title: "Text Area",
    type: "object",
    properties: {
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        inputType: {
            type: "string",
            enum: [
                "textarea"
            ]
        },
        type: {
            type: "string",
            enum: [
                "string"
            ]
        },
        placeholder: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        title: {
            type: "string",
            minLength: 1
        },
        defaultValuePath,
        defaultValue: {
            type: "string"
        },
        generativeAIPrompt: {
            type: "string"
        },
        useGenerativeAI: {
            type: "boolean"
        },
        columnHeaderOverride,
        disabled,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        formula
    },
    allOf: [
        {
            if: {
                properties: {
                    required: {
                        const: true
                    }
                }
            },
            then: {
                properties: {
                    useGenerativeAI: {
                        enum: [
                            false
                        ]
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    useGenerativeAI: {
                        const: true
                    }
                }
            },
            then: {
                properties: {
                    generativeAIPrompt: {
                        type: "string",
                        minLength: 1
                    }
                }
            }
        }
    ],
    required: [
        "name",
        "required",
        "inputType",
        "type",
        "placeholder",
        "title"
    ],
    additionalProperties: false
};
const dateSchema = {
    title: "Date",
    type: "object",
    properties: {
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        inputType: {
            type: "string",
            enum: [
                "date"
            ]
        },
        type: {
            type: "string",
            enum: [
                "string"
            ]
        },
        defaultToToday: {
            type: "boolean"
        },
        title: {
            type: "string",
            minLength: 1
        },
        placeholder: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        columnHeaderOverride,
        disabled,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        formula
    },
    required: [
        "name",
        "required",
        "inputType",
        "type",
        "defaultToToday",
        "title"
    ],
    additionalProperties: false
};
const damageDegreeSchema = {
    title: "Damage Degree",
    type: "object",
    properties: {
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        inputType: {
            type: "string",
            enum: [
                "DamageDegree"
            ]
        },
        type: {
            type: "string"
        },
        placeholder: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        title: {
            type: "string",
            minLength: 1
        },
        columnHeaderOverride,
        disabled,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate
    },
    required: [
        "name",
        "required",
        "inputType",
        "type",
        "placeholder",
        "title"
    ],
    additionalProperties: false
};
const textSchema = {
    title: "Text",
    type: "object",
    properties: {
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        inputType: {
            type: "string",
            enum: [
                "text"
            ]
        },
        type: {
            type: "string",
            enum: [
                "string"
            ]
        },
        placeholder: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        title: {
            type: "string",
            minLength: 1
        },
        defaultValuePath,
        defaultValue: {
            type: "string"
        },
        labelSize: {
            type: "string",
            enum: [
                "small",
                "medium"
            ]
        },
        columnHeaderOverride,
        disabled,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        uniqueIdentifier: {
            type: "string"
        },
        formula
    },
    required: [
        "name",
        "required",
        "inputType",
        "type",
        "placeholder",
        "title"
    ],
    additionalProperties: false
};
const booleanInputSchema = {
    title: "Boolean",
    type: "object",
    properties: {
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        type: {
            type: "string",
            enum: [
                "boolean"
            ]
        },
        inputType: {
            type: "string",
            enum: [
                "checkbox"
            ]
        },
        tooltipText: {
            type: "string"
        },
        title: {
            type: "string"
        },
        checkboxText: {
            type: "string",
            minLength: 1
        },
        columnHeaderOverride,
        defaultValuePath,
        disabled,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        formula
    },
    required: [
        "name",
        "required",
        "type",
        "title",
        "inputType",
        "checkboxText"
    ],
    additionalProperties: false
};
const numberWithUnitsSchema = {
    title: "Number with units",
    type: "object",
    properties: {
        inputType: {
            type: "string",
            enum: [
                "NumberWithUnits"
            ]
        },
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        title: {
            type: "string",
            minLength: 1
        },
        minimum: {
            type: "number"
        },
        maximum: {
            type: "number"
        },
        tooltipText: {
            type: "string"
        },
        defaultValuePath,
        defaultValue: {
            type: "number"
        },
        unitsDefaultValuePath: defaultValuePath,
        unitsDefaultValue: {
            type: "string"
        },
        enum: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    label: {
                        type: "string",
                        minLength: 1
                    },
                    value: {
                        type: "string",
                        minLength: 1
                    }
                },
                required: [
                    "label",
                    "value"
                ]
            },
            minItems: 1
        },
        columnHeaderOverride,
        disabled,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate
    },
    required: [
        "inputType",
        "name",
        "enum",
        "title",
        "required"
    ],
    additionalProperties: false
};
const propertyMarketValueSchema = {
    title: "Property Market Value",
    type: "object",
    properties: {
        inputType: {
            type: "string",
            enum: [
                "PropertyMarketValue"
            ]
        },
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        title: {
            type: "string",
            minLength: 1
        },
        columnHeaderOverride,
        tooltipText: {
            type: "string"
        },
        description: {
            type: "string"
        },
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        formula,
        enum: {
            type: "array",
            items: {
                type: "string",
                enum: [
                    "squareFootageEstimate",
                    "automatedAssessedValue",
                    "otherValueEstimate"
                ],
                minLength: 1
            }
        },
        overrides: {
            type: "object",
            properties: {
                overrides: {
                    type: "object",
                    properties: {
                        squareFootageEstimate: {
                            type: "object",
                            properties: {
                                description: {
                                    type: "string",
                                    description: "*FEMA preferred — Calculated by applying a value per square foot of the building."
                                },
                                adjustmentRatio: {
                                    type: "object",
                                    properties: {
                                        title: {
                                            type: "string"
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                viewOnCreate,
                viewOnRetrieve,
                canUpdate
            }
        }
    },
    required: [
        "inputType",
        "name",
        "title",
        "required"
    ],
    additionalProperties: false
};
const groupSchema = {
    title: "Field Group",
    type: "object",
    properties: {
        inputType: {
            type: "string",
            enum: [
                "group"
            ]
        },
        name: {
            type: "string"
        },
        title: {
            type: "string",
            minLength: 1
        },
        description: {
            type: "string"
        },
        properties: {
            $ref: "PropertiesArray"
        },
        required: {
            type: "boolean"
        },
        columns: {
            type: "integer"
        },
        heading: {
            type: "string",
            enum: Headings
        }
    },
    required: [
        "inputType",
        "title",
        "properties"
    ],
    additionalProperties: false
};
const userSchema = {
    title: "User",
    type: "object",
    properties: {
        inputType: {
            type: "string",
            enum: [
                "User"
            ]
        },
        name: {
            type: "string"
        },
        title: {
            type: "string",
            minLength: 1
        },
        required: {
            type: "boolean"
        },
        placeholder: {
            type: "string"
        },
        type: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        description: {
            type: "string"
        },
        disabled,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        userGroupSelection: {
            type: "array"
        },
        columnHeaderOverride,
        randomizeOptionOrder: {
            type: "boolean"
        }
    },
    required: [
        "inputType",
        "name",
        "required",
        "title"
    ],
    additionalProperties: false
};
const multiSelectSchema = {
    title: "Multi-select",
    type: "object",
    properties: {
        inputType: {
            type: "string",
            enum: [
                "multiSelect"
            ]
        },
        name: {
            type: "string"
        },
        type: {
            type: "string",
            enum: [
                "string",
                "number"
            ]
        },
        title: {
            type: "string",
            minLength: 1
        },
        required: {
            type: "boolean"
        },
        placeholder: {
            type: "string"
        },
        description: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        columnHeaderOverride,
        helperText,
        viewOnCreate,
        viewOnRetrieve,
        canUpdate,
        useAsTag: {
            type: "boolean"
        },
        enum: {
            type: "array",
            items: {
                oneOf: [
                    {
                        title: "Select Option String",
                        type: "string",
                        minLength: 1
                    },
                    {
                        title: "Select Option Label/Value Pair",
                        type: "object",
                        properties: {
                            label: {
                                type: "string",
                                minLength: 1
                            },
                            value: {
                                type: "string",
                                minLength: 1
                            },
                            display: {
                                type: [
                                    "string",
                                    "null"
                                ],
                                enum: Object.values(_constants.TAG_DISPLAY)
                            }
                        },
                        required: [
                            "label",
                            "value"
                        ]
                    }
                ]
            },
            minItems: 1
        },
        defaultValue: {
            type: "array",
            items: {
                type: "string"
            }
        },
        randomizeOptionOrder: {
            type: "boolean"
        }
    },
    required: [
        "inputType",
        "name",
        "type",
        "title",
        "required",
        "enum"
    ],
    additionalProperties: false
};
const uniqueIdSchema = {
    title: "Unique ID",
    type: "object",
    properties: {
        name: {
            type: "string"
        },
        required: {
            type: "boolean"
        },
        inputType: {
            type: "string",
            enum: [
                "UniqueId"
            ]
        },
        type: {
            type: "string",
            enum: [
                "string"
            ]
        },
        placeholder: {
            type: "string"
        },
        tooltipText: {
            type: "string"
        },
        title: {
            type: "string",
            minLength: 1
        },
        labelSize: {
            type: "string",
            enum: [
                "small",
                "medium"
            ]
        },
        columnHeaderOverride,
        disabled,
        helperText,
        viewOnRetrieve,
        canUpdate,
        viewOnCreate,
        prefix: {
            type: "string"
        },
        numberType: {
            type: "string",
            enum: NumberTypes
        }
    },
    required: [
        "name",
        "required",
        "inputType",
        "type",
        "placeholder",
        "title"
    ],
    additionalProperties: false
};
const schemas = {
    id: "PropertiesArray",
    type: "array",
    items: {
        oneOf: [
            documentUploaderSchema,
            tagsSchema,
            selectSchema,
            dateSchema,
            damageDegreeSchema,
            textSchema,
            textAreaSchema,
            numberSchema,
            booleanInputSchema,
            numberWithUnitsSchema,
            propertyMarketValueSchema,
            groupSchema,
            userSchema,
            multiSelectSchema,
            uniqueIdSchema
        ]
    }
};

//# sourceMappingURL=data:application/json;base64,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